import React, { useState, Fragment } from "react";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import DialogModal from "@core/components/dialogmodal";
import ImageModal from "@core/components/imagemodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const renderClient = (params) => {
  const { row } = params;

  if (row.image) {
    return <img alt="img" src={`${row.image}`} width="40px" height="40px" />;
  }
};

const LibraryBookList = (props) => {
  const [deleteId, setDeleteId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [categoryValue, setCategoryValue] = useState("");

  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    libraryBookList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    libraryCateList,
    fetchCategoryFilter,
    isFilter,
    setIsFilter,
    removeFilter,
    permission,
    role,
  } = props;

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const handleImageModal = (url) => {
    setImageUrl(url);
    setOpenImage(true);
  };

  const handleClose = () => {
    setOpenImage(false);
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 2,
      minWidth: 130,
      field: "title",
      headerName: "Book name",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "author",
      headerName: "author name",
    },
    {
      flex: 1,
      minWidth: 80,
      field: "image",
      headerName: "Image",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => handleImageModal(params.row.image)}
          >
            {renderClient(params)}
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 130,
      field: "cat_name",
      headerName: "Category",
    },
    {
      flex: 1,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const onChangeCategory = (e) => {
    const value = e.target.value;
    setIsFilter(true);
    setCategoryValue(value);
    fetchCategoryFilter(value);
  };

  const assemList = libraryBookList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      title: data.title,
      author: data.author,
      image: data.image,
      cat_id: data.cat_id,
      cat_name: data.cat_name,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          columns={removeaction}
          localeText={{ noRowsLabel: "No results found" }}
          rows={assemList}
          page={pageNumber}
          rowCount={Number(totalRecord)}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Library Books"
                : "",
              selectedRows: selectedRows,
              onClickDelete: () => handleDeleteModal(),
              libraryCateList: libraryCateList,
              onChangeCategory: onChangeCategory,
              categoryValue: categoryValue,
              filter: true,
              isFilter: isFilter,
              removeFilter: () => removeFilter(),
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}

      {openImage && (
        <ImageModal
          open={openImage}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </Fragment>
  );
};

export default LibraryBookList;
